<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">Comunicaciones</h1></div>
    </div>

    <!-- Sections -->
    <div class="row-cols-12 m-2 mt-0">
        <div class="row p-0 p-md-3 mb-0 align-items-center pt-1">
            <div class="mt-0 text-start mb-3 pb-3">
                <div class="d-grid mb-3 p-2">
                    <button type="button" class="btn btn-primary btn-lg mt-0" [routerLink]="['/more-comunicacion']">
                        <span class="icon">+ </span>
                        <span class="text">Nueva Comunicación</span>
                    </button>
                </div>

                <div class="row-cols-12 p-2 mb-3 ps-0 pe-0 input-group fade-in search-input-row">
                    <div class="rounded-start col-md-auto" id="search-addon">
                        <div class="mx-auto d-block p-1 d-inline-flex pt-1 ps-2"><i class="bi bi-search"></i></div>
                    </div>
                    <div class="col rounded">
                        <input
                            type="search"
                            class="form-control search-input shadow-none"
                            placeholder="Buscar por título, alcance o email"
                            aria-label="Search"
                            aria-describedby="search-addon"
                            (keyup)="searchTerm$.next($any($event.target).value)"
                        />
                    </div>
                    <div class="col-md-auto rounded-end text-end" id="mic-addon">
                        <div class="mx-auto d-block p-1 d-inline-flex"><i class="bi bi-mic"></i></div>
                    </div>
                </div>

                @if (error()) {
                    <div class="alert alert-danger mt-4" role="alert">
                        <small>{{ error() }}</small>
                    </div>
                }

                <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="p-0 m-0">
                        <b>Comunicaciones ({{ (comunicacionesFiltradas$ | async)?.length ?? 0 }})</b>
                    </span>
                </div>

                @for (comunicacion of (comunicacionesFiltradas$ | async) ?? []; track comunicacion.id) {
                    <a class="text-decoration-none text-dark" [routerLink]="['/more-comunicacion', comunicacion.id]">
                        <div class="comunicacion-card mt-3">
                            <div class="d-flex justify-content-between align-items-start">
                                <div class="comunicacion-title text-truncate">
                                    {{ comunicacion.x_titulo }}
                                </div>
                                <span class="badge-alcance">{{ getAlcanceLabel(comunicacion.x_alcance) }}</span>
                                <span class="badge-alcance">{{ getAppDestinoLabel(comunicacion.x_app) }}</span>
                            </div>

                            <div class="comunicacion-subtitle text-truncate">
                                {{ comunicacion.x_descripcion }}
                            </div>

                            <div class="comunicacion-extra">
                                {{ comunicacion.d_fecha | date:'dd/MM/yyyy HH:mm' }}
                                · Enviada a {{ comunicacion.n_enviados_ok ?? 0 }}/{{ comunicacion.n_destinatarios ?? 0 }}
                                · {{ getLeidoLabel(comunicacion) }}
                            </div>
                        </div>
                    </a>
                }

                @if (((comunicacionesFiltradas$ | async)?.length ?? 0) === 0) {
                    <div class="p-4 text-center text-detail-item">
                        No hay comunicaciones para mostrar.
                    </div>
                }
            </div>
        </div>
    </div>
</div>
